
import { Quest, QuestCategory } from '../../../types';

export const MEMORY_MASTER_QUESTS: Quest[] = [
  {
    id: 1500,
    category: QuestCategory.SkillBuilder,
    title: 'The First Key',
    questlineId: 'memory-master',
    isQuestlineStart: true,
    description: 'To become a Memory Master, you must first learn to hold a single, important key in your mind.',
    details: 'In an emergency, you might not have your contacts list. Your mission is to memorize one important number, like a parent\'s mobile number or the home phone number. Practice saying it out loud until you know it by heart.'
  },
  {
    id: 1501,
    category: QuestCategory.SkillBuilder,
    title: 'The Blueprint of the Mind',
    questlineId: 'memory-master',
    prerequisiteQuestId: 1500,
    description: 'The ultimate memory technique is the "Memory Palace". Your quest is to design the blueprint for your own.',
    details: 'The Memory Palace technique links things you want to remember to a location you know well. Your mission: choose your palace (your house is perfect). In your notebook, draw a map and choose 10 specific locations (loci) along a set path (e.g., 1. Front door, 2. Shoe rack, 3. Sofa...).'
  },
  {
    id: 1502,
    category: QuestCategory.SkillBuilder,
    title: 'Populating the Palace',
    questlineId: 'memory-master',
    prerequisiteQuestId: 1501,
    description: 'Your palace is built. Now it\'s time to fill it with information.',
    details: 'Ask an adult for a shopping list of 10 items. Now, mentally "place" each item in one of the locations in your palace. Make the image weird and memorable (e.g., for "milk", imagine a river of milk flowing from the front door). Practice walking through your palace and seeing each item.'
  },
  {
    id: 1503,
    category: QuestCategory.SkillBuilder,
    title: 'The Recall',
    questlineId: 'memory-master',
    prerequisiteQuestId: 1502,
    description: 'The information is stored. Can you retrieve it?',
    details: 'Without looking at the list, mentally walk through your Memory Palace. Recite the 10 items on the shopping list out loud as you "see" them in each location. You\'ll be amazed that they are all there!'
  },
  {
    id: 1504,
    category: QuestCategory.TeamUp,
    title: 'The Grand Tour',
    questlineId: 'memory-master',
    prerequisiteQuestId: 1503,
    description: 'You are now a Memory Master. It\'s time to demonstrate your new power.',
    details: 'Ask for a new list of 10 items and take a few minutes to memorize them in your palace. Then, give a family member a "tour" of your palace, amazing them by recalling the entire list perfectly.'
  }
];
